jQuery(function () {
  var selector = "[data-behaviour~=present-task]";

  jQuery(document).on("pjm:refresh", initState);

  // BEHAVIOUR
  function loadTaskUrl(element) {
    window.Sparkle.Tabs.selectTabByName("tasks");

    var url = jQuery(element).data("task-url");
    jQuery.ajax(url);
  }

  function removePresentationState(element) {
    jQuery(element).removeAttr("data-behaviour");
  }

  function initState() {
    if (!jQuery(selector).length) {
      Sparkle.PatientJourneyManager?.taskCompleteModal?.destroy();
    }

    jQuery(selector)
      .first()
      .each(function () {
        loadTaskUrl(this);
      });
    jQuery(selector).each(function () {
      removePresentationState(this);
    });
  }

  initState();
});
